import { render, staticRenderFns } from "./DataScreenMap.vue?vue&type=template&id=2a446be5&scoped=true&"
import script from "./DataScreenMap.vue?vue&type=script&lang=js&"
export * from "./DataScreenMap.vue?vue&type=script&lang=js&"
import style0 from "./DataScreenMap.vue?vue&type=style&index=0&id=2a446be5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a446be5",
  null
  
)

export default component.exports